module.exports = __webpack_public_path__ + "img/pac-man.26627464.png";